<template>
  <v-select
    v-if="$props.type == 'select'"
    :options="$props.selectOptions"
    :label="$props.selectLabel"
    :reduce="$props.selectReduce"
    :searchable="$props.selectSearchable"
    :clearable="$props.selectClearable"
    :disabled="$props.disabled"
    :placeholder="$props.placeholder ? $props.placeholder : 'Seç'"
    :value="modelValue"
    @input="onInput"
    @open="onFocus"
  >
    <template #no-options> Sonuç bulunamadı! </template>
  </v-select>
  <label v-else-if="$props.type == 'check'" class="checkbox">
    <input type="checkbox" :checked="$props.modelValue" @change="onInput" />
    <span class="control"></span>
    <span class="name">
      <slot></slot>
    </span>
  </label>
  <label
    v-else-if="$props.type == 'radio'"
    class="radio"
    :class="{ test: $props.radioValue == $props.value }"
    :style="[
      $props.radioValue == $props.value
        ? { background: 'rgba(240, 118, 98, 1)' }
        : {},
    ]"
  >
    <input
      type="radio"
      :name="$props.radioName ? 'radio-' + $props.radioName : ''"
      xxx-:value="$props.radioValue"
      :checked="$props.radioValue == $props.value"
      @change="onInput"
    />
    <span class="control"></span>
    <span class="name">
      <slot></slot>
    </span>
  </label>
  <input
    v-else-if="$props.type == 'kimlikNo'"
    class="textbox"
    type="tel"
    v-mask="'###########'"
    :disabled="$props.disabled"
    :readonly="$props.disabled"
    :placeholder="$props.placeholder"
    :value="modelValue"
    @input="onInput"
    @focus="onFocus"
  />
  <input
    v-else-if="$props.type == 'dogumTarihi'"
    class="textbox"
    type="tel"
    v-mask="'##/##/####'"
    :disabled="$props.disabled"
    :readonly="$props.disabled"
    :placeholder="$props.placeholder ? $props.placeholder : 'GG/AA/YYYY'"
    :value="modelValue"
    @input="onInput"
  />
  <input
    v-else-if="$props.type == 'cepNo'"
    class="textbox"
    type="tel"
    v-mask="'+90 5## ### ## ##'"
    :disabled="$props.disabled"
    :readonly="$props.disabled"
    :placeholder="$props.placeholder"
    :value="modelValue"
    @input="onInput"
  />
  <input
    v-else-if="$props.type == 'ePosta'"
    class="textbox"
    type="email"
    :disabled="$props.disabled"
    :readonly="$props.disabled"
    :placeholder="$props.placeholder"
    :value="modelValue"
    @input="onInput"
  />
  <input
    v-else-if="$props.type == 'captcha'"
    class="textbox"
    type="tel"
    v-mask="'#####'"
    :disabled="$props.disabled"
    :readonly="$props.disabled"
    :placeholder="$props.placeholder ? $props.placeholder : 'Güvenlik Metni'"
    :value="modelValue"
    @input="onInput"
  />
  <input
    v-else-if="$props.type == 'smsDogrulamaKodu'"
    class="textbox"
    type="number"
    pattern="[0-9]{6}"
    inputmode="numeric"
    v-mask="'######'"
    :disabled="$props.disabled"
    :readonly="$props.disabled"
    :placeholder="$props.placeholder ? $props.placeholder : 'Sms Kodu'"
    :value="modelValue"
    @input="onInput"
  />
  <input
    v-else
    class="textbox"
    type="text"
    :disabled="$props.disabled"
    :readonly="$props.disabled"
    :placeholder="$props.placeholder"
    :value="modelValue"
    @input="onInput"
  />
</template>

<script>
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import { mask } from "vue-the-mask";

export default {
  components: {
    vSelect: vSelect,
  },
  directives: {
    mask,
  },
  props: {
    modelValue: [String, Boolean, Number, Object],
    type: {
      type: String,
      validator: function (value) {
        return (
          [
            "select",
            "check",
            "radio",
            "kimlikNo",
            "dogumTarihi",
            "cepNo",
            "ePosta",
            "captcha",
            "text",
            "smsDogrulamaKodu",
          ].indexOf(value) !== -1
        );
      },
    },
    selectOptions: {
      type: Array,
    },
    selectLabel: {
      type: String,
    },
    selectReduce: {
      type: Function,
    },
    selectSearchable: {
      type: Boolean,
      default: true,
    },
    selectClearable: {
      type: Boolean,
      default: true,
    },
    radioName: {
      type: String,
    },
    radioValue: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    value: {
      // type can be anything
      type: [String, Number, Boolean, Array, Object, Date],
    },
  },
  emits: ["update:modelValue", "focus"],
  data() {
    return {
      plakaIlKodlari: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59",
        "60",
        "61",
        "62",
        "63",
        "64",
        "65",
        "66",
        "67",
        "68",
        "69",
        "70",
        "71",
        "72",
        "73",
        "74",
        "75",
        "76",
        "77",
        "78",
        "79",
        "80",
        "81",
      ],
    };
  },
  methods: {
    onInput(e) {
      if (this.$props.type === "select") {
        this.$emit("update:modelValue", e);
      } else if (this.$props.type === "plakaIlKodu") {
        this.$emit("update:modelValue", e);
      } else if (this.$props.type === "check") {
        this.$emit("update:modelValue", e.target.checked);
      } else if (this.$props.type === "radio" && e.target.checked) {
        this.$emit("update:modelValue", this.$props.radioValue);
        this.$emit("change-radio", this.$props.radioValue);
      } else {
        this.$emit("update:modelValue", e.target.value);
      }
    },
    onFocus() {
      this.$emit("focus");
    },
  },
};
</script>
